export {
  COMPANY_PERMISSIONS,
  COMPANY_ROLE_PERMISSIONS,
  COMPANY_SOCIAL_PLATFORMS,
} from './company.ts';
